// Path: ./src/app/components/AccordionMenu/index.tsx
import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface Props {
  children: React.ReactNode;
  title: string;
  inLineStyle?: Object;
  dataTestId?: string;
}
export function ControlledAccordions({
  children,
  title,
  inLineStyle,
  dataTestId,
}: Props) {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div data-testid="controlledaccordions-test-id">
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        data-testid={dataTestId}
        style={{
          backgroundColor: expanded ? "#787878" : "#4c4c4c",
          color: "white",
          border: 0,
          boxShadow: "none",
          ...inLineStyle,
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
        >
          <Typography style={{ fontSize: "20px" }}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
}
